import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsEditSidebar.styles'
import ReportsTabSlider from 'modules/reports/components/Tab/Slider'
import ReportsEditFiltersTab from 'modules/reports/tabs/Edit/Filters/ReportsEditFiltersTab'
import ReportsEditViewTab from 'modules/reports/tabs/Edit/View/ReportsEditViewTab'
import ReportsSelect from 'modules/reports/components/Select'

type Props = {
  className?: string
}

function ReportsEditSidebar(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'EditSidebar')

  return (
    <div className={`${classes.root} ${props.className}`} data-testid={p('title')}>
      <header className={classes.headerWrapper}>
        <ReportsSelect
          name=""
          value=""
          options={[]}
          label={pt('group-label')}
          data-testid={p('group-select')}
        />
      </header>

      <ReportsTabSlider contentClassName={classes.contentWrapper} data-testid={p('tab-slider')}>
        <ReportsEditFiltersTab />
        <ReportsEditViewTab />
      </ReportsTabSlider>
    </div>
  )
}

export default ReportsEditSidebar
